<div class="main">
    <div class="container error-card">
        <span class="center error-icon">
        <esp-icon name="warning"></esp-icon>
    </span>
        <span class="center error-text">Something went wrong!!</span>

    </div>

</div>
